(ns entities.partner.specs
  (:require
    [cljs.spec.alpha :as s]))

(s/def ::domain string?)
(s/def ::name string?)
(s/def ::phone-number string?)
(s/def ::uri string?)
(s/def ::login (s/keys :req-un [::name
                                ::uri]))
(s/def ::logins (s/coll-of ::login))
(s/def ::partner (s/keys :req-un [::domain
                                  ::name
                                  ::phone-number]
                         :opt-un [::logins]))
